module.exports = __webpack_public_path__ + "img/logo2_cn.7f94bf06.webp";